import { type Instance, types } from 'mobx-state-tree';

export const STATUS_CERTIFIED = 'CERTIFIED';
export const STATUS_NO_MATCH = 'NO_MATCH';
export const STATUS_NEUTRAL = 'NEUTRAL';
export const STATUS_MATCH = 'MATCH';
export const STATUS_CUSTOM = 'CUSTOM';
export const STATUSES = [
  STATUS_CERTIFIED,
  STATUS_MATCH,
  STATUS_NO_MATCH,
  STATUS_NEUTRAL,
  STATUS_CUSTOM,
];

export const RoleRequirementStatus = types.union(
  types.literal(STATUS_CERTIFIED),
  types.literal(STATUS_NO_MATCH),
  types.literal(STATUS_NEUTRAL),
  types.literal(STATUS_MATCH),
  types.literal(STATUS_CUSTOM),
);

export type RoleRequirementStatusType = Instance<typeof RoleRequirementStatus>;
